import dayjs from "dayjs"; 
import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router";
import { motion } from "framer-motion";
import Popover from "@mui/material/Popover";
import Select from "react-select";
import IRMenu from "./IRMenu";
import KeyManagerialPersonsModal from "./KeyManagerialPersonsModal";
import CommonDatePicker from "../../../myfin_v2/elements/CommonDatePicker";
import DeletePopup from "../../../myfin_v2/elements/DeletePopup";
import SuccessPopup from "../../../myfin_v2/elements/SuccessPopup";
import ErrorPopup from "../../../myfin_v2/elements/ErrorPopup";
import commoncss from "../../../myfin_v2/css/common.module.css"
import buttoncss from "../../../myfin_v2/css/button.module.css";
import investmentRegisterCss from "../../../myfin_v2/css/investmentRegister.module.css";
import { getKeyInvestmentPersons, getLinkedCompanies, deleteKeyManagerialPerson, getInvestmentRegisterForms, updateKeyManagerialPerson } from "../../../WorkSpace/Components/ApiServices/apiHandler";
import swal from "sweetalert";
import { Button } from "../../../myfin_v2/elements/Button";
import { ReactComponent as LeftArrowIcon } from "../../../myfin_v2/assets/icons/left_arrow.svg";
import { ReactComponent as DotIcon } from "../../../myfin_v2/assets/icons/dot.svg";
import { ReactComponent as PlusIcon } from "../../../myfin_v2/assets/icons/plus.svg";
import { ReactComponent as PlusPrimaryIcon } from "../../../myfin_v2/assets/icons/plusprimary.svg";
import { ReactComponent as MenuDotsIcon } from "../../../myfin_v2/assets/icons/menu_dot.svg";
import { ReactComponent as EditIcon } from "../../../myfin_v2/assets/icons/edit.svg";
import { ReactComponent as DownGreyIcon } from "../../../myfin_v2/assets/icons/down_grey.svg";
import { ReactComponent as DownArrow } from "../../../myfin_v2/assets/icons/down-arrow.svg";
import { ReactComponent as SearchIcon } from "../../../myfin_v2/assets/icons/searchPri.svg";
import { ReactComponent as FilterIcon } from "../../assets/icons/filter.svg";
import { ReactComponent as CloseIcon } from "../../assets/icons/close_grey.svg";
import CustomDropdownIndicator from "../../../myfin_v2/elements/CustomDropdownIndicator";

const customSelectStyles = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: '#ffffff',
        borderColor: '#c2e6d1',
        boxShadow: state.isFocused ? '0 0 0 1px #c2e6d1' : 'none',
        borderRadius: '6px',
        '&:hover': {
            borderColor: '#c2e6d1',
        },
        minHeight: '37px',
        height: '37px',
        borderWidth: '1px',
        cursor: 'pointer',
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: '0 8px',
        display: 'flex',
        alignItems: 'center',
        height: '33px',
    }),
    input: (provided) => ({
        ...provided,
        color: '#205a46',
        margin: 0,
        padding: 0,
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        fontSize: '13px',
        margin: 0,
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#205a46',
        fontSize: '13px',
        margin: 0,
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: '#1A4338',
        padding: '4px',
        ':hover': {
            color: '#1A4338',
        },
    }),
    indicatorSeparator: () => ({ display: 'none' }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: '#ffffff',
        border: '1px solid #c2e6d1',
        borderRadius: '6px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
        marginTop: '6px',
        zIndex: 9999,
    }),
    menuList: (provided) => ({
        ...provided,
        padding: '4px',
        borderRadius: '6px',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: (state.isSelected || state.isFocused) ? '#f4faf5' : 'transparent',
        color: '#205a46',
        padding: '10px 12px',
        cursor: 'pointer',
        fontSize: '13px',
        borderRadius: '4px',
        marginBottom: '2px',
        fontWeight: (state.isSelected || state.isFocused) ? 600 : 400,
        ':active': {
            backgroundColor: '#e8f6ed',
            color: '#205a46',
        },
        ':hover': {
            backgroundColor: '#f4faf5',
            color: '#205a46',
        },
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        padding: '8px 12px',
    }),
};

const KeyManagerialPersons = () => {

    const { irId } = useParams();
    const history = useHistory();

    const [anchorEl, setAnchorEl] = useState(null);
    const [openPopoverId, setOpenPopoverId] = useState(null);
    const [selectedData, setSelectedData] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalType, setModalType] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [keyPersons, setKeyPersons] = useState([]);
    const [editableRows, setEditableRows] = useState([]);
    const [showHeaderSearch, setShowHeaderSearch] = useState(false);
    const [headerSearchValue, setHeaderSearchValue] = useState("");
    const [selectedCompany, setSelectedCompany]                               = useState(null);
    const [openDropdown, setOpenDropdown]                                     = useState(false);
    const [companySearch, setCompanySearch]                                   = useState("");
    const [highlightedIndex, setHighlightedIndex]                             = useState(0);
    const dropdownRef                                                         = useRef(null);
    const [deletePopup, setDeletePopup]                                       = useState({ isOpen: false, id: null });
    const [successPopup, setSuccessPopup]                                     = useState({ isOpen: false, message: "" });
    const [errorPopup, setErrorPopup]                                         = useState({ isOpen: false, message: "" });
    const [registerName, setRegisterName]                                     = useState("");

    // ── Replaced static companyList with API-driven state ─────────────────────
    const [companyList, setCompanyList] = useState([]);

    // ── Fetch linked companies from API ───────────────────────────────────────
    useEffect(() => {
        if (!irId) return;
        getLinkedCompanies(irId)
            .then((res) => {
                const companies = res.data?.companies || [];
                setCompanyList(companies);
            })
            .catch((err) => {
                console.error("Failed to fetch linked companies:", err);
            });

        getInvestmentRegisterForms(irId)
            .then(res => setRegisterName(res.data?.investmentRegister?.name || "Investment Register"))
            .catch(err => console.error(err));
    }, [irId]);

    const open = Boolean(anchorEl);

    const handleAdd = () => {
        setSelectedData(null);
        setModalType("add");
        setModalOpen(true);
    };

    const handleMenuClick = (event, id) => {
        setAnchorEl(event.currentTarget);
        setOpenPopoverId(id);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setOpenPopoverId(null);
    };

    const handleEdit = (item) => {
        setSelectedData(item);
        setModalType("edit");
        setModalOpen(true);
        handleClose();
    };

  const handleDeleteClick = (id) => {
      setDeletePopup({ isOpen: true, id });
      handleClose();
  };

  const handleConfirmDelete = async () => {
      const id = deletePopup.id;
      setDeletePopup({ isOpen: false, id: null });
      try {
          const response = await deleteKeyManagerialPerson(irId, id);
          if (response.status === 200) {
              setSuccessPopup({ isOpen: true, message: "Record deleted successfully." });
              fetchKeyManagerialPersons();
          }
      } catch (error) {
          console.error("Failed to delete record:", error);
          const errMsg = error?.response?.data?.error || error?.response?.data?.message || "Failed to delete record";
          setErrorPopup({ isOpen: true, message: errMsg });
      }
  };

  const handleSave = async () => {
      try {
          const promises = editableRows.map((row) => {
              const original = keyPersons.find(r => r._id === row._id);
              if (
                  original &&
                  (original.name !== row.name ||
                   original.designation !== row.designation ||
                   original.dateOfAppointment !== row.dateOfAppointment ||
                   original.dateOfResignation !== row.dateOfResignation)
              ) {
                  const payload = {
                      companyID: row.companyID || (selectedCompany?._id !== "all" ? selectedCompany?._id : undefined),
                      name: row.name,
                      designation: row.designation,
                      dateOfAppointment: row.dateOfAppointment ? dayjs(row.dateOfAppointment).format("DD-MM-YYYY") : "",
                      dateOfResignation: row.dateOfResignation ? dayjs(row.dateOfResignation).format("DD-MM-YYYY") : "",
                  };
                  return updateKeyManagerialPerson(irId, row._id, payload);
              }
              return null;
          }).filter(Boolean);

          if (promises.length > 0) {
              await Promise.all(promises);
              setSuccessPopup({ isOpen: true, message: "Key managerial persons updated successfully" });
              fetchKeyManagerialPersons();
          } else {
              setSuccessPopup({ isOpen: true, message: "No changes detected" });
          }
          setIsEditing(false);
      } catch (error) {
          console.error("Failed to update key managerial persons:", error);
          const errMsg = error?.response?.data?.error || error?.response?.data?.message || "Failed to update key managerial persons";
          setErrorPopup({ isOpen: true, message: errMsg });
      }
  };

    const handleModalClose = () => {
        setModalOpen(false);
        setSelectedData(null);
        setModalType(null);
    };

    const handleRowChange = (id, field, value) => {
        setEditableRows((prev) =>
            prev.map((row) =>
                row._id === id ? { ...row, [field]: value } : row
            )
        );
    };

    const fetchKeyManagerialPersons = async (searchQuery = headerSearchValue) => {
        try {
            const companyId = (selectedCompany?._id && selectedCompany._id !== "all") ? selectedCompany._id : undefined;
            const res = await getKeyInvestmentPersons(irId, companyId, searchQuery);
            if (res.data.success) {
                const persons = res.data.keyManagerialPersons || [];
                setKeyPersons(persons);
                setEditableRows(persons);
            }
        } catch (error) {
            console.log("Error fetching Key Managerial Persons:", error);
        }
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setOpenDropdown(false);
                setCompanySearch("");
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        if (companyList.length > 0 && !selectedCompany) {
            setSelectedCompany(companyList[0]);
        }
    }, [companyList]);

    useEffect(() => {
        if (selectedCompany) fetchKeyManagerialPersons(headerSearchValue);
    }, [selectedCompany?._id]);

    const companyOptions = [
        { _id: "all", company_name: "All" },
        ...companyList
    ];

    const filteredCompanyList = companyOptions.filter(c =>
        c.company_name.toLowerCase().includes((openDropdown ? companySearch : "").toLowerCase())
    );

    const handleDropdownKeyDown = (e) => {
        if (!openDropdown) {
            if (e.key === "ArrowDown" || e.key === "Enter") {
                setOpenDropdown(true);
                setHighlightedIndex(0);
                e.preventDefault();
            }
            return;
        }

        if (e.key === "ArrowDown") {
            e.preventDefault();
            setHighlightedIndex((prev) =>
                prev < filteredCompanyList.length - 1 ? prev + 1 : 0
            );
        } else if (e.key === "ArrowUp") {
            e.preventDefault();
            setHighlightedIndex((prev) =>
                prev > 0 ? prev - 1 : filteredCompanyList.length - 1
            );
        } else if (e.key === "Enter") {
            e.preventDefault();
            if (filteredCompanyList.length > 0 && filteredCompanyList[highlightedIndex]) {
                const comp = filteredCompanyList[highlightedIndex];
                setSelectedCompany(comp);
                setCompanySearch("");
                setOpenDropdown(false);
            }
        } else if (e.key === "Escape") {
            setOpenDropdown(false);
            setCompanySearch("");
        }
    };

    const handleSearchSubmit = (searchVal = headerSearchValue) => {
        fetchKeyManagerialPersons(searchVal);
    };

    const handleSearchKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handleSearchSubmit(headerSearchValue);
        }
    };

    const handleSearchClose = () => {
        setShowHeaderSearch(false);
        setHeaderSearchValue("");
        fetchKeyManagerialPersons("");
    };

    return (
        <>
            <div className={`d-flex ${commoncss.pageContent}`}>
                <IRMenu
                    activeTab={"Key Managerial Persons"}
                    registerID={irId}
                />
                <motion.div
                    initial={{ x: 200, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: 200, opacity: 0 }}
                    transition={{ duration: 1, ease: "easeInOut" }}
                    className={investmentRegisterCss.irLayout} style={{ paddingTop: "15px" }}
                >
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "5px" }}>
                        {/* ── Company Dropdown ── */}
                        <div className={investmentRegisterCss.dropdownWrapper} ref={dropdownRef}>
                            <div
                                className={investmentRegisterCss.dropdownField}
                                onClick={() => setOpenDropdown(true)}
                            >
                                <input
                                    type="text"
                                    style={{
                                        border: "none",
                                        background: "transparent",
                                        outline: "none",
                                        color: "#205a46",
                                        fontSize: "14px",
                                        width: "100%",
                                        padding: 0,
                                        cursor: "pointer",
                                    }}
                                    placeholder="Select Company"
                                    value={openDropdown ? companySearch : (selectedCompany ? selectedCompany.company_name : "Select Company")}
                                    onFocus={() => {
                                        setCompanySearch("");
                                        setHighlightedIndex(0);
                                        setOpenDropdown(true);
                                    }}
                                    onChange={(e) => {
                                        setCompanySearch(e.target.value);
                                        setHighlightedIndex(0);
                                        setOpenDropdown(true);
                                    }}
                                    onKeyDown={handleDropdownKeyDown}
                                />
                                <motion.span
                                    animate={{ rotate: openDropdown ? 180 : 0 }}
                                    transition={{ duration: 0.2 }}
                                    className={investmentRegisterCss.chevron}
                                    style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setOpenDropdown(prev => !prev);
                                    }}
                                >
                                    <DownArrow />
                                </motion.span>
                            </div>

                            {openDropdown && (
                                <div className={investmentRegisterCss.dropdownMenuScrollable}>
                                    {filteredCompanyList.length > 0 ? (
                                        filteredCompanyList.map((company, i) => (
                                            <div
                                                key={company._id}
                                                className={`${investmentRegisterCss.dropdownItem} ${selectedCompany?._id === company._id || highlightedIndex === i ? investmentRegisterCss.dropdownItemActive : ""}`}
                                                style={highlightedIndex === i ? { backgroundColor: "#f4faf5", color: "#205a46" } : {}}
                                                onMouseEnter={() => setHighlightedIndex(i)}
                                                onClick={() => {
                                                    setSelectedCompany(company);
                                                    setCompanySearch("");
                                                    setOpenDropdown(false);
                                                }}
                                            >
                                                {company.company_name}
                                            </div>
                                        ))
                                    ) : (
                                        <div className={investmentRegisterCss.dropdownItem} style={{ color: "#b3c0bd", cursor: "default" }}>
                                            No companies found
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>

                        {/* ── Header Actions ── */}
                        <div className={investmentRegisterCss.iRHeader}>
                            {showHeaderSearch ? (
                                <div className={investmentRegisterCss.headerSearchBar}>
                                    <SearchIcon 
                                        className={investmentRegisterCss.headerSearchBarIcon} 
                                        style={{ cursor: "pointer" }}
                                        onClick={() => handleSearchSubmit(headerSearchValue)}
                                    />
                                    <input
                                        autoFocus
                                        type="text"
                                        className={investmentRegisterCss.headerSearchInput}
                                        placeholder="Type something..."
                                        value={headerSearchValue}
                                        onChange={(e) => setHeaderSearchValue(e.target.value)}
                                        onKeyDown={handleSearchKeyDown}
                                    />
                                    <CloseIcon
                                        className={investmentRegisterCss.headerSearchClose}
                                        onClick={handleSearchClose}
                                    />
                                </div>
                            ) : (
                                <SearchIcon
                                    style={{ cursor: "pointer" }}
                                    onClick={() => setShowHeaderSearch(true)}
                                />
                            )}
                        </div>
                    </div>

                    {/* ── Tables Container with #ffffff background and border radius ── */}
                    <div
                        className={investmentRegisterCss.shareCapitalLayout}
                        style={{
                            flexDirection: "column",
                            height: "auto",
                            minHeight: "calc(103vh - 120px)",
                            border: "1px solid #EAEEED",
                            background: "#ffffff",
                            borderRadius: "16px",
                            padding: "20px",
                            overflowY: "auto",
                            marginBottom: "20px",
                        }}
                    >
                        <div className={investmentRegisterCss.tableLayout} style={{ width: "100%" }}>
                            <div className={investmentRegisterCss.tableConatiner}>
                                <div className={investmentRegisterCss.tableTitle}>
                                    <span>Key Managerial Persons</span>

                                    {!isEditing ? (
                                        <span className="d-flex gap-1">
                                            <Button
                                                btnColor={buttoncss.greyBg}
                                                icon={<EditIcon />}
                                                class_={investmentRegisterCss.editBtn}
                                                onClick={() => setIsEditing(true)}
                                            />
                                            <Button
                                                btnColor={buttoncss.greyBg}
                                                icon={<PlusPrimaryIcon />}
                                                class_={investmentRegisterCss.addBtnRow}
                                                onClick={handleAdd}
                                            />
                                        </span>
                                    ) : (
                                        <div className={investmentRegisterCss.saveCancelWrap}>
                                            <button
                                                className={investmentRegisterCss.cancelBtn}
                                                onClick={() => {
                                                    setIsEditing(false);
                                                    setEditableRows([...keyPersons]);
                                                }}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                className={investmentRegisterCss.saveBtn}
                                                onClick={handleSave}
                                            >
                                                Save
                                            </button>
                                        </div>
                                    )}
                                </div>

                                <table>
                                    <thead>
                                        <tr>
                                            <th style={{ textAlign: "left", paddingLeft: "20px" }}>Name</th>
                                            <th style={{ textAlign: "left" }}>Designation</th>
                                            <th>Date of appointment</th>
                                            <th>Date of resignation</th>
                                            <th style={{ textAlign: "right", paddingRight: "20px" }}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {editableRows.length === 0 ? (
                                            <tr>
                                                <td colSpan="5" style={{ textAlign: "center", padding: "20px", color: "#b3c0bd" }}>No key managerial persons data</td>
                                            </tr>
                                        ) : (
                                            editableRows.map((item) => (
                                                <tr key={item._id}>
                                                <td style={{ textAlign: "left", paddingLeft: "20px" }}>
                                                    {isEditing ? (
                                                        <div style={{ width: "220px", minWidth: "150px" }}>
                                                            <input
                                                                type="text"
                                                                className={investmentRegisterCss.inputShare}
                                                                value={item.name || ""}
                                                                onChange={(e) => handleRowChange(item._id, "name", e.target.value)}
                                                                placeholder="Enter name"
                                                            />
                                                        </div>
                                                    ) : (item.name)}
                                                </td>

                                                <td style={{ textAlign: "left" }}>
                                                    {isEditing ? (
                                                        <div style={{ width: "220px", minWidth: "150px" }}>
                                                            <input
                                                                type="text"
                                                                className={investmentRegisterCss.inputShare}
                                                                value={item.designation || ""}
                                                                onChange={(e) => handleRowChange(item._id, "designation", e.target.value)}
                                                                placeholder="Enter designation"
                                                            />
                                                        </div>
                                                    ) : (item.designation)}
                                                </td>

                                                <td style={{ textAlign: "center" }}>
                                                    {isEditing ? (
                                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                                            <CommonDatePicker
                                                                value={item.dateOfAppointment ? dayjs(item.dateOfAppointment).format("YYYY-MM-DD") : ""}
                                                                onChange={(val) => handleRowChange(item._id, "dateOfAppointment", val)}
                                                                containerClass=""
                                                                containerStyle={{ backgroundColor: "#ffffff", border: "1px solid #c2e6d1", borderRadius: "6px", height: "37px", padding: "0 10px", boxShadow: "none", display: "flex", alignItems: "center", justifyContent: "space-between", width: "140px", margin: "0 auto" }}
                                                                inputStyle={{ backgroundColor: "transparent", color: "#205a46", fontSize: "14px", height: "100%", width: "100%", border: "none", outline: "none", padding: 0 }}
                                                            />
                                                        </div>
                                                    ) : item.dateOfAppointment ? (
                                                        dayjs(item.dateOfAppointment).format("DD-MMM-YYYY")
                                                    ) : ("-")}
                                                </td>

                                                <td style={{ textAlign: "center" }}>
                                                    {isEditing ? (
                                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                                            <CommonDatePicker
                                                                value={item.dateOfResignation ? dayjs(item.dateOfResignation).format("YYYY-MM-DD") : ""}
                                                                onChange={(val) => handleRowChange(item._id, "dateOfResignation", val)}
                                                                containerClass=""
                                                                containerStyle={{ backgroundColor: "#ffffff", border: "1px solid #c2e6d1", borderRadius: "6px", height: "37px", padding: "0 10px", boxShadow: "none", display: "flex", alignItems: "center", justifyContent: "space-between", width: "140px", margin: "0 auto" }}
                                                                inputStyle={{ backgroundColor: "transparent", color: "#205a46", fontSize: "14px", height: "100%", width: "100%", border: "none", outline: "none", padding: 0 }}
                                                            />
                                                        </div>
                                                    ) : item.dateOfResignation ? (
                                                        dayjs(item.dateOfResignation).format("DD-MMM-YYYY")
                                                    ) : ("-")}
                                                </td>

                                                <td style={{ textAlign: "right", paddingRight: "20px" }}>
                                                    <MenuDotsIcon
                                                        style={{ cursor: "pointer" }}
                                                        onClick={(e) => handleMenuClick(e, item._id)}
                                                    />
                                                    <Popover
                                                        open={Boolean(anchorEl) && openPopoverId === item._id}
                                                        anchorEl={anchorEl}
                                                        onClose={handleClose}
                                                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                                                        elevation={0}
                                                        PaperProps={{
                                                            style: {
                                                                boxShadow: 'none',
                                                                backgroundColor: 'transparent',
                                                                overflow: 'visible'
                                                            }
                                                        }}
                                                    >
                                                        <div className={investmentRegisterCss.irOptions} style={{ width: "160px" }}>
                                                            <span style={{ borderBottom: "1px solid #EAEEED" }} onClick={() => handleEdit(item)}>Edit</span>
                                                            <span onClick={() => handleDeleteClick(item._id)}>Delete</span>
                                                        </div>
                                                    </Popover>
                                                </td>
                                            </tr>
                                         )))
                                         
                                         }
                                     </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                </motion.div>
            </div>

            {modalOpen && (
                <KeyManagerialPersonsModal
                    handleClose={handleModalClose}
                    data={selectedData}
                    type={modalType}
                    investmentID={irId}
                    refreshData={fetchKeyManagerialPersons}
                    companyId={selectedData?.companyID || (selectedCompany?._id !== "all" ? selectedCompany?._id : companyList[0]?._id)}
                    onSuccess={(msg) => setSuccessPopup({ isOpen: true, message: msg || "Record saved successfully" })}
                    onError={(msg) => setErrorPopup({ isOpen: true, message: msg || "Something went wrong" })}
                />
            )}

            <DeletePopup
                isOpen={deletePopup.isOpen}
                onConfirm={handleConfirmDelete}
                onCancel={() => setDeletePopup({ isOpen: false, id: null })}
            />
            
            <SuccessPopup
                isOpen={successPopup.isOpen}
                message={successPopup.message}
                onClose={() => setSuccessPopup({ isOpen: false, message: "" })}
            />

            <ErrorPopup
                isOpen={errorPopup.isOpen}
                message={errorPopup.message}
                onClose={() => setErrorPopup({ isOpen: false, message: "" })}
            />
        </>
    );
};

export default KeyManagerialPersons;